import React from 'react'
import { Card, CardContent, Grid, Typography, Box } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { formatNumber } from '@auteco/utils/formatsNumber'

const aplicaConsignacionActivo = (v) =>
  v === 1 || v === '1' || v === true || (v !== undefined && v !== null && !Number.isNaN(Number(v)) && Number(v) === 1)

const getResaltadoDesdeFondo = (baseBackgroundColor) => {
  switch (baseBackgroundColor) {
    case '#e8e8e8':
      return { backgroundColor: '#c8c8c8', textColor: '#212121' }
    case '#d2eeff':
      return { backgroundColor: '#bbdefb', textColor: '#0d47a1' }
    case '#e6d4ff':
      return { backgroundColor: '#d1c4e9', textColor: '#4a148c' }
    case '#ffd4d4':
      return { backgroundColor: '#ffc1c1', textColor: '#b71c1c' }
    default:
      return { backgroundColor: baseBackgroundColor, textColor: 'black' }
  }
}

const InventarioCard = ({
  title,
  value,
  testId,
  backgroundColor = '#d2eeff',
  textColor = 'black',
  highlight = false,
}) => {
  const resaltado = highlight ? getResaltadoDesdeFondo(backgroundColor) : null
  const bg = resaltado ? resaltado.backgroundColor : backgroundColor
  const col = resaltado ? resaltado.textColor : textColor
  return (
  <Grid item xs={1.5} sm={1.5} md={1.5}>
    <Card
      data-testid={testId}
      sx={{
        backgroundColor: bg,
        color: col,
        textAlign: 'center',
        minHeight: '60px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
      }}
    >
      <CardContent sx={{ py: 0.4, px: 0.5 }}>
        <Typography
          variant="body2"
          component="div"
          sx={{
            fontSize: '13px',
            mb: 0.3,
            fontWeight: '500',
            lineHeight: 1.1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.35,
          }}
        >
          {title}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '17px' }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
  )
}

const PromedioSellOutCard = ({ value, highlight = false }) => {
  const r = highlight ? getResaltadoDesdeFondo('#ffd4d4') : null
  return (
  <Grid item xs={1.5} sm={1.5} md={1.5}>
    <Card
      sx={{
        backgroundColor: r ? r.backgroundColor : '#ffd4d4',
        color: r ? r.textColor : 'inherit',
        border: '1px solid #ffb8b8',
        borderRadius: '6px',
        textAlign: 'center',
        minHeight: '60px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <CardContent sx={{ py: 0.4, px: 0.5 }}>
        <Typography variant="body2" sx={{ fontSize: '10px', mb: 0.3, fontWeight: '500', lineHeight: 1.1 }}>
          Promedio 3M Sell Out
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
          {parseFloat(value)}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
  )
}

const InventarioCards = ({ inventarioData }) => {
  const h = inventarioData?.highlightInventario || {}
  const mostrarChulitoConsignacion = aplicaConsignacionActivo(
    inventarioData?.aplica_consignacion,
  )
  const tituloConsignacion = mostrarChulitoConsignacion ? (
    <>
      Consignación
      <CheckCircleIcon
        sx={{
          fontSize: 15,
          color: '#2e7d32',
          opacity: 0.75,
        }}
        aria-label="Aplica consignación"
        titleAccess="Aplica consignación"
      />
    </>
  ) : (
    'Consignación'
  )
  const inventarioItems = [
    {
      title: 'Inv total en sitio',
      value: formatNumber(inventarioData?.inventario_total || 0),
      testId: 'inventario-total',
      backgroundColor: '#e8e8e8',
      highlight: h.total,
    },
    {
      title: 'CKD',
      value: formatNumber(inventarioData?.inventario_real_ckd || 0),
      testId: 'ckd',
      backgroundColor: '#d2eeff',
      highlight: h.ckd,
    },
    {
      title: 'Ensamblado',
      value: formatNumber(inventarioData?.inventario_real_pt || 0),
      testId: 'ensamblado',
      backgroundColor: '#d2eeff',
      highlight: h.ensamblado,
    },
    {
      title: 'En control calidad',  
      value: formatNumber(inventarioData?.inventario_real_control_calidad || 0),
      testId: 'control-calidad',
      backgroundColor: '#e6d4ff',
      highlight: h.controlCalidad,
    },
    {
      title: 'Bloqueado',
      value: formatNumber(inventarioData?.inventario_real_bloqueado || 0),
      testId: 'bloqueado',
      backgroundColor: '#e6d4ff',
      highlight: h.bloqueado,
    },
    {
      title: tituloConsignacion,
      value: formatNumber(inventarioData?.inventario_real_consignacion || 0),
      testId: 'consignacion',
      backgroundColor: '#e8e8e8',
      highlight: h.consignacion,
    },
    {
      title: 'Inv Socios',
      value: formatNumber(inventarioData?.inventario_red || 0),
      testId: 'inventario-socios',
      backgroundColor: '#e8e8e8',
      highlight: h.inventarioSocios,
    },
  ]

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={1}>
        {/* Libre utilización en la parte superior centrada */}
        {/* <LibreUtilizacionCard 
          value={inventarioData?.libre_utilizacion || 0} 
        /> */}
        
        {/* Tarjetas de inventario */}
        {inventarioItems.map((item) => (
          <InventarioCard
            key={item.testId}
            title={item.title}
            value={item.value}
            testId={item.testId}
            backgroundColor={item.backgroundColor}
            highlight={item.highlight}
          />
        ))}
        
        {/* Promedio 3M Sell Out en la misma fila */}
        <PromedioSellOutCard 
          value={formatNumber(inventarioData?.promedio_sell_out_ultimos_3_meses || 0)}
          highlight={h.promedio3MSellOut}
        />
      </Grid>
    </Box>
  )
}

export default InventarioCards 